import React, { forwardRef } from "react";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase/firebaseConfig";
import DarkModeToggle from "./DarkModeToggle";

import { FiLogOut } from "react-icons/fi";


const SidebarNav = forwardRef(({ activeTab, setActiveTab, onClose, isMenuOpen }, ref) => {

    const navigate = useNavigate();

    const handleClick = (tab) => {
        setActiveTab(tab);
        if (isMenuOpen) onClose(); // hanya tutup kalau mobile menu buka
    };
    const handleLogout = async () => {
        const confirmLogout = window.confirm("Are you sure you want to log out?");
        if (!confirmLogout) return;
        await signOut(auth);
        navigate("/login");
    };

    return (
        <div
            ref={ref}
            className={`sidebar ${isMenuOpen ? "mobile-visible" : "desktop-only"}`}
        >
            <button
                className={activeTab === "dashboard" ? "active" : ""}
                onClick={() => handleClick("dashboard")}
            >
                Dashboard
            </button>
            <button
                className={activeTab === "about" ? "active" : ""}
                onClick={() => handleClick("about")}
            >
                About
            </button>
            <button
                className={activeTab === "participations" ? "active" : ""}
                onClick={() => handleClick("participations")}
            >
                Participations
            </button>
            <button
                className={activeTab === "fundraisers" ? "active" : ""}
                onClick={() => handleClick("fundraisers")}
            >
                Fundraisers
            </button>
            <button
                className={activeTab === "people" ? "active" : ""}
                onClick={() => handleClick("people")}
            >
                People
            </button>
            <button onClick={handleLogout} style={{ marginTop: "auto", color: "red" }}>
                <FiLogOut style={{ verticalAlign: "middle", marginRight: 6 }} />
                Log Out
            </button>
            <DarkModeToggle />

        </div>
    );
});

export default SidebarNav;
